import styled from '@emotion/styled';
import { CardHeader, Typography, blue, grey, tokens } from '@galaxy-react/core';

export const HoverContentStyled = styled(CardHeader)({
  '& .fui-CardHeader__header': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  '& .fui-CardHeader__image': {
    height: '100%',
  },

  '& .fui-CardHeader__action': {
    marginLeft: '16px',
    width: '325px',
  },
});

export const HoverHeaderStyled = styled('div')({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
});

export const HeadingStyled = styled(Typography)({
  fontWeight: tokens.fontWeightSemibold,
  color: blue[700],
  whiteSpace: 'nowrap',
});

export const HoverIconsStyled = styled('div')({
  display: 'flex',
  gap: tokens.spacingVerticalS,
  marginLeft: 'auto',
});

export const HeaderActionStyled = styled('div')({
  display: 'flex',
  gap: tokens.spacingVerticalXXL,
  width: '100%',
  justifyContent: 'flex-end',
});

export const DateStyled = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '90px',
});

export const StarPlaceholderStyled = styled('div')({
  width: '16px',
  height: '16px',
  margin: `0 ${tokens.spacingVerticalXS}`,
});

export const CardBodyContainerStyled = styled('div')({
  display: 'flex',
  gap: tokens.spacingVerticalM,
  alignItems: 'center',
});

export const ChipsWrapperStyled = styled('div')({
  display: 'flex',
  marginTop: tokens.spacingHorizontalS,
  height: 'min-content',
  gap: tokens.spacingVerticalS,
});

export const DescriptionStyled = styled(Typography)({
  fontSize: tokens.fontSizeBase200,
  lineHeight: tokens.lineHeightBase200,
  color: grey[800],
  marginTop: tokens.spacingHorizontalS,
  whiteSpace: 'nowrap',
});

export const HeadingWrapperStyled = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  gap: '16px',
});

export const FirstColImgStarStyled = styled('div', {
  shouldForwardProp: (prop) => prop !== 'alignment',
})<{ alignment?: boolean }>(({ alignment }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: alignment ? 'flex-start' : 'center',
}));

export const PopoverChipsWrapperStyled = styled('div')({
  display: 'flex',
  padding: '16px',
  gap: tokens.spacingVerticalS,
});

export const PopoverListStyled = styled('ul')({
  padding: `0 ${tokens.spacingVerticalL}`,
  margin: '0',
  listStyle: 'none',
});

export const PopoverLiStyled = styled('li')({
  display: 'flex',
  '&:first-of-type': {
    paddingTop: tokens.spacingHorizontalL,
  },
  '&:last-child': {
    paddingBottom: tokens.spacingHorizontalL,
  },
  paddingTop: tokens.spacingHorizontalS,

  gap: tokens.spacingVerticalL,
});

export const PopoverTypographyStyled = styled('h4')({
  margin: `${tokens.spacingHorizontalL} 0 0`,
  color: blue[700],
});

export const PopoverContentStyled = styled('div')({
  color: grey[800],
  gap: tokens.spacingVerticalL,
  display: 'flex',
  alignItems: 'center',
  svg: {
    color: blue[700],
  },
});

export const ActionAvatarWrapperStyled = styled('div')({
  display: 'flex',
  gap: tokens.spacingVerticalXS,
  alignItems: 'center',
});

export const ViewsStyled = styled('div')({
  color: grey[600],
  fontSize: tokens.fontSizeBase200,
  lineHeight: tokens.lineHeightBase200,
});
